





































import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import ComboBox from './ComboBox.vue'
import TagsComboBoxItem from './TagsComboBoxItem.vue'

const REQUEST_URL_BASIS = `${location.origin}/watchout/api/tags`
const SEARCH_PHRASE_PARAMETER_KEY = 'q'
const REQUEST_TIMEOUT_DURATION = 400

export default Vue.extend({
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    searchPhrase: String,
    selectedTagIdentifier: Number,
    multiple: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ComboBox,
    TagsComboBoxItem
  },
  data () {
    return {
      tags: [] as any[],
      requestTimeoutIdentifier: undefined as undefined | number,
      multiselectComponentData: undefined as any,
      searchRequested: undefined as undefined | boolean,
      localSearchPhrase: '' as string
    }
  },
  computed: {
    placeholderText () : string {
      if (this.multiple) {
        const selected = Array.isArray(this.value) ? this.value : []
        if (selected.length) {
          return ''
        }
        return this.$t('search_tags') as string
      }
      const single = this.value as any
      return (single && single.name) || this.searchPhrase || (this.$t('search_tag') as string)
    }
  },
  mounted () {
    this.multiselectComponentData = ((this.$refs.comboBox as InstanceType<typeof ComboBox>).$refs.multiselect as Multiselect).$data
    if (!this.multiple) {
      this.multiselectComponentData.search = this.searchPhrase || ''
    }
    this.search()
  },
  watch: {
    selectedTagIdentifier () {
      if (this.multiple) {
        return
      }
      this.$nextTick(() => {
        if (!this.searchRequested) {
          if (this.selectedTagIdentifier) {
            this.$emit('input', this.tags.find(tag => tag['id'] === this.selectedTagIdentifier) || this.tags[0] || null)
          } else {
            this.$emit('input', null)
          }
        }
      })
    },
    tags () {
      if (this.multiple) {
        return
      }
      if (this.selectedTagIdentifier) {
        this.$emit('input', this.tags.find(tag => tag['id'] === this.selectedTagIdentifier) || this.tags[0] || null)
      } else if (this.searchPhrase) {
        this.$emit('input', this.tags[0] || null)
      } else {
        this.$emit('input', null)
      }
    },
    searchPhrase () {
      if (this.multiple) {
        return
      }
      this.multiselectComponentData.search = this.searchPhrase || ''
      this.search()
    }
  },
  methods: {
    onSearchChange (phrase: string) {
      if (this.multiple) {
        this.localSearchPhrase = phrase || ''
        this.search()
        return
      }
      if (phrase !== this.searchPhrase) {
        this.$emit('update:searchPhrase', phrase)
      }
    },
    onInput (option: any) {
      if (this.multiple) {
        this.$emit('input', Array.isArray(option) ? option : [])
        return
      }
      if (option) {
        this.$emit('input', option)
      } else {
        this.$emit('reselected-tag')
      }
    },
    search () {
      this.searchRequested = true
      clearTimeout(this.requestTimeoutIdentifier)
      this.requestTimeoutIdentifier = setTimeout(() => {
        const requestURL = new URL(REQUEST_URL_BASIS)
        const phrase = this.multiple ? this.localSearchPhrase : this.searchPhrase
        phrase && requestURL.searchParams.set(SEARCH_PHRASE_PARAMETER_KEY, phrase)
        fetch(requestURL.toString()).then(response => response.json()).then(data => {
          if (data['count']) {
            this.tags = data['results']
          } else {
            this.tags = []
          }
        }).finally(() => this.searchRequested = false)
      }, REQUEST_TIMEOUT_DURATION)
    }
  }
})
